import {
  ENQUEUE_NOTIFICATION,
  CLOSE_NOTIFICATION,
  REMOVE_NOTIFICATION,
  type EnqueueNotificationAction,
  type NotificationsAction,
} from '~/shared/notifications/actions'

type Notification = EnqueueNotificationAction['notification'] & { dismissed?: boolean }

interface NotificationsState {
  notifications: Notification[]
}

const defaultState: NotificationsState = {
  notifications: [],
}

export default (state = defaultState, action: NotificationsAction): NotificationsState => {
  switch (action.type) {
    case ENQUEUE_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.notification],
      }

    case CLOSE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.map(notification =>
          action.dismissAll || notification.key === action.key
            ? { ...notification, dismissed: true }
            : { ...notification },
        ),
      }

    case REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.key !== action.key),
      }

    default:
      return state
  }
}
